import ConsentHeader from './ConsentHeader';
import ConsentActions from './ConsentActions';
import styles from './ConsentBanner.module.css';

interface ConsentBannerProps {
  onClose: () => void;
  onAccept: () => void;
  onReject: () => void;
}

export default function ConsentBanner({
  onClose,
  onAccept,
  onReject,
}: ConsentBannerProps): JSX.Element {
  return (
    <section
      className={styles.banner}
      id="analytics-consent"
      role="region"
      aria-labelledby="analytics-consent-title"
    >
      <ConsentHeader onClose={onClose} />
      <p>
        Para melhorar sua experiência no site, utilizamos cookies analíticos do
        Google Analytics, com sua autorização, para entender as visitas e a
        navegação. Ao clicar em “Aceitar todos”, você autoriza o uso desses
        cookies. Se escolher “Recusar todos”, os cookies analíticos serão
        desativados e você continuará tendo acesso às funcionalidades do site.
        Você pode revisar sua escolha a qualquer momento pelo botão de
        preferências de cookies no canto inferior esquerdo.
      </p>
      <ConsentActions onAccept={onAccept} onReject={onReject} />
    </section>
  );
}
